export const SET_LOCATION = '@@location/set_location';
export const USER_FETCH_SUCCEEDED = '@@user/user_fetch_succeeded';
export const USER_FETCH_FAILED = '@@user/user_fetch_failed';
export const BOOKING_STATE_FETCH_SUCCESS = '@@booking/booking_state_succeeded';
export const BOOKING_STATE_FETCH_FAILURE = '@@booking/booking_state_failure';
